import React from "react";
import { Row, Col } from "reactstrap";
import { PageHeader } from "../Shared";

const MainDisplay = () => {
  return (
    <div>
      <Row>
        <Col>
          <PageHeader pageId="home" pageTitle="Home" />
        </Col>
      </Row>

      <div className="content-wrapper">
        <h5 className="bold">Wallet Management Service</h5>        
      </div>
    </div>
  );
};

export default MainDisplay;
